<template>
  <v-card>
    <v-card-title>Rekapan Absensi Siswa</v-card-title>
    <v-card-text>
      <form
        @submit.prevent="
          () => {
            options.page = filter.page = 1;
            get();
          }
        "
      >
        <v-row>
          <v-col lg="12" cols="12">
            <v-btn
              role="a"
              target="_blank"
              :href="pdf_url"
              text
              color="red"
              dark
            >
              Export PDF
            </v-btn>
          </v-col>
          <v-col lg="3" cols="6">
            <v-autocomplete
              label="Rombel"
              v-model="filter.rombel_id"
              :items="data.rombel"
              @change="
                () => {
                  options.page = filter.page = 1;
                  get();
                }
              "
              :rules="[(v) => !!v || 'Silahkan pilih rombel']"
              clearable
              :error="!!!filter.rombel_id"
              hint="Silahkan pilih rombel"
            ></v-autocomplete>
          </v-col>
          <v-col :lg="filter.semester == '0' ? 3 : 5" cols="6">
            <v-select
              :items="[
                {
                  value: '1',
                  text: 'Ganjil (Juli - Desember)',
                },
                {
                  value: '2',
                  text: 'Genap (Januari - Juni)',
                },
                {
                  value: '0',
                  text: 'Lainnya / Per-Bulan',
                },
              ]"
              @change="
                options.page = filter.page = 1;
                get();
              "
              v-model="filter.semester"
              label="Semester"
              :rules="[(v) => !!v || 'Silahkan pilih opsi semester']"
              :error="!!!filter.semester"
              hint="Silahkan pilih opsi semester"
            ></v-select>
          </v-col>
          <v-col cols="6" lg="3" v-if="filter.semester == '0'">
            <v-select
              v-model="filter.bulan"
              @input="
                () => {
                  options.page = filter.page = 1;
                  get();
                }
              "
              label="Bulan"
              placeholder="Pilih Bulan"
              :rules="[(v) => !!v || 'bulan harus dipilih']"
              :items="data.bulan"
            ></v-select>
          </v-col>
          <v-col
            :cols="filter.semester == '0' ? 6 : 12"
            :lg="filter.semester == '0' ? 3 : 4"
          >
            <v-text-field
              type="number"
              v-model="filter.tahun"
              @change="
                () => {
                  options.page = filter.page = 1;
                  get();
                }
              "
              label="Tahun"
              placeholder="Pilih Tahun"
              :rules="[(v) => !!v || 'tahun harus dipilih']"
            ></v-text-field>
          </v-col>
          <v-col cols="12" lg="6">
            <v-autocomplete
              label="Guru"
              v-model="filter.guru_id"
              @change="
                options.page = filter.page = 1;
                getMapel();
                get();
              "
              placeholder="Pilih Guru"
              :items="data.guru"
              :disabled="$root.app.xlevel !== 'user' ? false : true"
            >
            </v-autocomplete>
          </v-col>
          <v-col cols="12" lg="6">
            <v-autocomplete
              label="Mata Pelajaran"
              v-model="filter.mata_pelajaran_id"
              @change="
                options.page = filter.page = 1;
                get();
              "
              placeholder="Pilih Mata Pelajaran"
              :items="data.mata_pelajaran"
            >
            </v-autocomplete>
          </v-col>
        </v-row>
        <button type="submit" hidden="true"></button>
      </form>
      <v-data-table
        :footer-props="{
          'items-per-page-options': [5, 10, 20, 50, 100],
        }"
        disable-sort
        :headers="[
          {
            text: 'NIS',
            value: 'nis',
          },
          {
            text: 'Nama Siswa',
            value: 'nama',
          },
          {
            text: 'Rombel',
            value: 'rombel',
          },
          {
            text: 'Masuk',
            value: 'masuk',
          },
          {
            text: 'Izin',
            value: 'izin',
          },
          {
            text: 'Sakit',
            value: 'sakit',
          },
          {
            text: 'Alpa',
            value: 'alpa',
          },
        ]"
        :items="datas"
        :loading="is.loading"
        loading-text="Loading... Please wait"
        :server-items-length="recordsTotal"
        :options.sync="options"
      >
        <template slot="item.rombel" slot-scope="{ item }">
          {{ item.rombel.rombel }}
        </template>
      </v-data-table>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  data() {
    return {
      datas: [],
      modal: {
        create: false,
        edit: false,
        delete: false,
      },
      req: {},
      is: {
        loading: true,
        submit: false,
      },
      filter: {
        limit: 10,
        search: "",
        page: 1,
      },
      options: {},
      recordsTotal: 0,
      data: {
        rombel: [],
        mata_pelajaran: [],
        guru: [],
        bulan: [
          {
            value: 1,
            text: "Januari",
          },
          {
            value: 2,
            text: "Februari",
          },
          {
            value: 3,
            text: "Maret",
          },
          {
            value: 4,
            text: "April",
          },
          {
            value: 5,
            text: "Mei",
          },
          {
            value: 6,
            text: "Juni",
          },
          {
            value: 7,
            text: "Juli",
          },
          {
            value: 8,
            text: "Agustus",
          },
          {
            value: 9,
            text: "September",
          },
          {
            value: 10,
            text: "Oktober",
          },
          {
            value: 11,
            text: "November",
          },
          {
            value: 12,
            text: "Desember",
          },
        ],
      },
      pdf_url: "",
    };
  },
  created() {
    this.filter.guru_id = parseInt(this.$root.app.xid);

    this.getBulanIni();
    this.getData();
    this.get();
  },
  watch: {
    options(val) {
      this.filter.limit = val.itemsPerPage;
      this.filter.page = val.page;
      this.get();
    },
  },
  methods: {
    getBulanIni() {
      const date = new Date();
      var bulan = date.getMonth() + 1;

      this.filter.tahun = date.getFullYear();
      this.filter.bulan = bulan;
    },
    get() {
      this.req = {
        rombel_id: "",
      };
      if (this.filter.rombel_id && this.filter.semester) {
        this.is.loading = true;
        if (this.filter.rombel_id == null) {
          this.filter.rombel_id = "";
        }
        this.$root.app.http
          .get("/api/siswa/presensi", this.filter)
          .then((res) => {
            this.datas = res.data;
            this.recordsTotal = res.recordsTotal;
            this.pdf_url = res.pdf_url;
            this.is.loading = false;
          });
      } else {
        this.datas = [];
        setTimeout(() => {
          this.is.loading = false;
        }, 600);
      }
    },
    getData() {
      this.data.rombel = [];
      this.$root.app.http.get("/api/rombel").then((res) => {
        res.data.forEach((item) => {
          this.data.rombel.push({ text: item.rombel, value: item.id });
        });
      });

      this.data.guru = [
        {
          value: "",
          text: "Semua Guru",
        },
      ];
      this.$root.app.http.get("/api/guru").then((res) => {
        res.data.forEach((item) => {
          this.data.guru.push({
            value: item.id,
            text: item.nama,
          });
        });
      });

      this.getMapel();
    },
    getMapel() {
      this.data.mata_pelajaran = [
        {
          value: "",
          text: "Semua Mata Pelajaran",
        },
      ];

      this.$root.app.http
        .get("/api/matapelajaran", {
          guru_id: this.filter.guru_id,
        })
        .then((res) => {
          res.data.forEach((item) => {
            this.data.mata_pelajaran.push({
              value: item.id,
              text: item.nama,
            });
          });
        });

      this.filter.mata_pelajaran_id = "";
    },
  },
};
</script>
